import type { Field, FieldCellValue } from '@lighthouse/core'
import { ViewFieldValuePreviewer } from '@lighthouse/shared'
import { usePopupState } from 'material-ui-popup-state/hooks'
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react'
import styled from 'styled-components'

interface ListCellProps {
    field: Field
    data?: FieldCellValue
    size?: number
    isColumn?: boolean
    isBold?: boolean
}

const SCxListCell = styled.div<{ size?: number }>`
    position: relative;
    width: 100%;
    flex-shrink: 0;
    font-size: var(--font-size-normal);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 8px;

    & div {
        font-size: ${({ size }) => (size ? `${size}px` : 'unset')};
    }
`

export const ListValue: React.FC<ListCellProps> = ({ field, data, size, isColumn, isBold }) => {
    const listCellRef = useRef<HTMLDivElement>(null)
    const [width, setWidth] = useState(0)

    const popperAnchorRef = useRef<HTMLDivElement>(null)
    const popperState = usePopupState({
        variant: 'popper',
        popupId: 'ListCellEditorPopup'
    })

    useLayoutEffect(() => {
        if (!listCellRef.current) {
            return
        }
        const { width } = listCellRef.current.getBoundingClientRect()
        setWidth(width)
    }, [isColumn])

    const handleOpen = useCallback(() => {
        popperState.open(popperAnchorRef.current)
    }, [popperState])

    return (
        <SCxListCell onDoubleClick={handleOpen} size={size} ref={listCellRef}>
            <ViewFieldValuePreviewer
                width={isColumn ? width : undefined}
                field={field}
                disabled
                isBold={isBold}
                data={data}
                isWrap={false}
            />
        </SCxListCell>
    )
}
